import { useContext } from "react";
import { FlashContext } from "../components/flash/FlashOverlay";
export function useFlash() {
    const pushFlash = useContext(FlashContext).pushFlash;
    if (typeof pushFlash === "undefined") {
        throw new Error("useFlash must be used within a FlashOverlay");
    }
    return pushFlash;
}
